export const featureFlags = {
    budget: true,

    // Módulo de Atendimentos (chamado TAS)
    tasOccurrenceLogsTab: true,
    tasOccurrenceVehicleContainer: true,
    tasOccurrenceVinculateOccurrence: true,
}